module.exports = __webpack_public_path__ + "img/picture-6.f1fffdca.png";